import React from 'react'
import { withRouter } from 'react-router'

import Description from './abstract/Description'
import Window from '../../../../../common/Window'

class Description2 extends Description {
  render () {
    const NenkinSetting = this.getSetting('NenkinSetting')
    const KenkouSetting = this.getSetting('KenkouSetting')
    const KaigoSetting = this.getSetting('KaigoSetting')
    const KodomoSetting = this.getSetting('KodomoSetting')
    const KoyouSetting = this.getSetting('KoyouSetting')
    if (NenkinSetting && KenkouSetting && KaigoSetting && KodomoSetting && KoyouSetting) {
      return (
        <div className='kw-description'>
          <p>２．「社会保険料内訳」</p>

          <table>
            <tbody>
              <tr>
                <th>①厚生年金負担率</th>
                <td>
                  {this.getWareki(NenkinSetting.startMonth)}分から{this.getWareki(NenkinSetting.endMonth)}分までに適用される厚生年金保険料率。
                  保険料を被保険者及び雇用主がそれぞれ半額を負担するため、負担率は同率である。
                </td>
              </tr>
              <tr>
                <th>②健康保険負担率</th>
                <td>{this.getWareki(KenkouSetting.startMonth)}分 から適用される協会けんぽの健康保険料率（都道府県ごとに異なる）。</td>
              </tr>
              <tr>
                <th>③介護保険負担率</th>
                <td>
                  {this.getWareki(KaigoSetting.startMonth)}分 から適用される協会けんぽの介護保険料率{Number(KaigoSetting.ryouritsu * 100).toFixed(2)}%×加入率（40～64歳の被保険者割合※）
                  ={Number(KaigoSetting.ryouritsu * KaigoSetting.kanyuuwariai * 100).toFixed(3)}%<br />
                  保険料を被保険者および雇用主がそれぞれ半額負担するため、負担率は同率である。<br />
                  ※{Number(KaigoSetting.kanyuuwariai * 100).toFixed(1)}%(「健康保険・船員保険被保険者実態調査報告(平成26年10月)」)
                </td>
              </tr>
              <tr>
                <th>④子ども・子育て拠出金<br />負担率</th>
                <td>
                  子ども・子育て拠出金率{Number(KodomoSetting.ryouritsu * 100).toFixed(2)}%<br />
                  ※児童手当拠出金が平成27年度より名称変更。雇用主が負担する。
                </td>
              </tr>
              <tr>
                <th>⑤雇用保険負担率</th>
                <td>
                  {this.getWareki(KoyouSetting.startMonth)}分から{this.getWareki(KoyouSetting.endMonth)}分までに適用される雇用保険料率。<br />
                  雇用主負担分{Number(KoyouSetting.koyounushiRyouritsu * 100).toFixed(3)}%、本人負担分{Number(KoyouSetting.honninRyouritsu * 100).toFixed(3)}%、
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    } else {
      Window.alert('対象見積書作成日時点の初期値データが登録されていません。\n日本型枠工事業協会へご連絡ください。', () => {
        this.props.history.push('/company_user/estimation/' + this.props.estimationType)
        Window.closeDialog()
      })
      return (
        <div>-</div>
      )
    }
  }
}
export default withRouter(Description2)



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationEdit/LaborUnitPriceTab/Description2.js